import { STANDARD_NUM_SYS_OPTION } from '../const';
import { locale } from '../locale';
import { I18nNumber } from './number';
/**
 * 通过语种获取当前数字系统小数点
 * @param lang 语种
 * @returns
 */
export const getDecimalSeparator = function (lang) {
    try {
        const parts = new Intl.NumberFormat(lang, STANDARD_NUM_SYS_OPTION).formatToParts(1.1);
        const decimal = parts.find((i) => i.type === 'decimal');
        return ((decimal === null || decimal === void 0 ? void 0 : decimal.value) || '.');
    }
    catch (error) {
        console.error(error);
        return '.';
    }
};
/**
 * 通过语种获取当前数字系统格式化配置
 * @param lang 语种
 * @returns
 */
export function getNumSysFormatConf(lang) {
    const getGroupSeparator = () => {
        try {
            const parts = new Intl.NumberFormat(lang, STANDARD_NUM_SYS_OPTION).formatToParts(11111);
            const group = parts.find((i) => i.type === 'group');
            return (group === null || group === void 0 ? void 0 : group.value) || '';
        }
        catch (error) {
            console.error(error);
            return '';
        }
    };
    const getSecondaryGroupSize = () => {
        var _a;
        try {
            const parts = new Intl.NumberFormat(lang, STANDARD_NUM_SYS_OPTION).formatToParts(111111);
            const groups = parts.filter((i) => i.type === 'integer');
            const secondaryGroup = groups[groups.length - 2];
            return ((_a = secondaryGroup === null || secondaryGroup === void 0 ? void 0 : secondaryGroup.value) === null || _a === void 0 ? void 0 : _a.length) || 0;
        }
        catch (error) {
            console.error(error);
            return 0;
        }
    };
    return {
        decimalSeparator: getDecimalSeparator(lang),
        groupSeparator: getGroupSeparator(),
        groupSize: 3,
        secondaryGroupSize: getSecondaryGroupSize(),
        fractionGroupSeparator: '',
        fractionGroupSize: 0,
    };
}
/**
 *通过语种获取当前数字系统格式化字符串
 * @param lang
 * @returns
 */
export const numberFormat = function (num, lang, options) {
    try {
        const str = new Intl.NumberFormat(lang, {
            ...STANDARD_NUM_SYS_OPTION,
            ...(options || {}),
        }).format(num);
        return str;
    }
    catch (error) {
        console.error(error);
        return num;
    }
};
/**
 *通过语种获取当前数字系统格式化字符串
 * @param lang
 * @returns
 */
export const numberUnFormat = function (numStr, lang) {
    try {
        const config = getNumSysFormatConf(lang);
        if (!config.groupSeparator || !config.decimalSeparator) {
            return numStr;
        }
        return numStr.replace(config.groupSeparator, '').replace(config.decimalSeparator, '.');
    }
    catch (error) {
        console.error(error);
        return numStr;
    }
};
/**
 *基于 Intl 自动数字简写
 * @param num - 数字
 * @param lang - 语种
 * @returns
 */
export const numberCompact = function (num, lang, options) {
    try {
        const format = new Intl.NumberFormat(lang, {
            notation: 'compact',
            ...STANDARD_NUM_SYS_OPTION,
            ...(options || {}),
        });
        const value = format.format(num);
        const parts = format.formatToParts(num);
        const compact = parts.find((i) => i.type === 'compact');
        const partsValue = parts.reduce((accumulator, currentValue) => {
            if (['integer', 'group', 'decimal', 'fraction'].includes(currentValue.type)) {
                return `${accumulator}${currentValue.value}`;
            }
            return accumulator;
        }, '');
        return {
            value,
            parts: {
                value: new I18nNumber(numberUnFormat(partsValue, lang), lang),
                compact: compact === null || compact === void 0 ? void 0 : compact.value,
            },
        };
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
/**
 *基于 Intl 自动数字简写
 * @param num - 数字
 * @param lang - 语种
 * @returns
 */
export const numberCompactByCon = function (num, conversion, lang) {
    try {
        const i18nNumber = new I18nNumber(num, lang);
        const cons = (locale[lang] || locale['en-US']).NUMBER_COMPACT;
        const con = cons.reduce((accumulator, currentValue) => {
            if (Math.abs(currentValue.conversion - conversion) <
                Math.abs(accumulator.conversion - conversion)) {
                return currentValue;
            }
            return accumulator;
        }, cons[0]);
        return {
            value: i18nNumber.div(con.conversion),
            compact: con.compact,
        };
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
/**
 *通过语种格式化货币金额
 * @param amount
 * @param currency
 * @param lang
 * @returns
 */
export const currencyFormat = (amount, currency, lang, options) => {
    try {
        const formatter = new Intl.NumberFormat(lang, {
            ...STANDARD_NUM_SYS_OPTION,
            style: 'currency',
            currency: currency,
            ...(options || {}),
        });
        return formatter.format(amount);
    }
    catch (error) {
        console.error(error);
        return NaN;
    }
};
